import { get } from 'lodash-es';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['loadingWidgets']),
    // Default widget payload, keyed by the component's `widgetKey`. `isEmptyWidget`/`emptyReason`
    // below read `this.widgetData`, so providing it here means a widget only needs to declare
    // `widgetKey`. Widgets that source their data differently (e.g. by widgetName or a local `data`
    // prop) just define their own `widgetData`, which overrides this.
    widgetData() {
      return get(this.$store.state.widgets, this.widgetKey, {});
    },
    isReady() {
      return !get(this.loadingWidgets, this.widgetKey, false);
    },
    bodyClasses() {
      return !this.isReady && this.isFirstLoad ? 'widget-loading' : '';
    },
    isEmptyWidget() {
      return this.widgetData && 'empty_reason' in this.widgetData;
    },
    emptyReason() {
      return this.widgetData?.empty_reason || 'no_data';
    },
  },
  data: () => ({
    isFirstLoad: true,
  }),
};
